export function removeNullCharacters(obj) {
    if (typeof obj === 'string') {
        return obj.replace(/\u0000/g, '');
    } else if (Array.isArray(obj)) {
        return obj.map(removeNullCharacters);
    } else if (typeof obj === 'object' && obj !== null) {
        const cleaned = {};
        for (const key in obj) {
            cleaned[key] = removeNullCharacters(obj[key]);
        }
        return cleaned;
    } else {
        return obj;
    }
}


// herlper functions to check conditions on user data donations 
function hasKeys(obj, keys = []) {
    return keys.every((k) => Object.prototype.hasOwnProperty.call(obj, k));
}

function missingKeys(obj, keys = []) {
    return keys.filter((k) => !Object.prototype.hasOwnProperty.call(obj, k));
}

/**
 * Takes parsed JSON from conversations.json and returns:
 *  - ok: boolean
 *  - reason: string (if not ok)
 */
function validateConversationSignature(json, platform) {
    const isArray = Array.isArray(json);
    const sample = isArray ? json?.[0] : json;

    if (!sample || typeof sample !== "object") {
        return { ok: false, reason: "conversations.json has an unexpected structure (not an object/array of objects)." };
    }

    const signatures = {
        claude: {
            required: ["uuid", "name", "created_at", "updated_at", "account", "chat_messages"],
            forbiddenAny: ["mapping", "current_node", "conversation_id"],
        },
        deepseek: {
            required: ["id", "title", "inserted_at", "updated_at", "mapping"],
            forbiddenAny: ["uuid", "chat_messages", "current_node", "conversation_id"],
        },
        chatgpt: {
            requiredAnySets: [
                ["mapping", "current_node"],           
                ["mapping", "conversation_id"],         
            ],
            forbiddenAny: ["chat_messages", "inserted_at"], 
        },
    };

    const sig = signatures[platform];
    if (!sig) return { ok: true }; // unknown platform -> don't block here

    // Forbidden keys check (if ANY forbidden appears, fail closed)
    if (sig.forbiddenAny && sig.forbiddenAny.some((k) => Object.prototype.hasOwnProperty.call(sample, k))) {
        return { ok: false, reason: `This file looks like a different platform export (found key not expected for ${platform}).` };
    }

    // Required exact set
    if (sig.required) {
        const miss = missingKeys(sample, sig.required);
        if (miss.length > 0) {
        return { ok: false, reason: `This file does not match ${platform} export format (missing: ${miss.join(", ")}).` };
        }
        return { ok: true };
    }

    if (sig.requiredAnySets) {
        const matches = sig.requiredAnySets.some((set) => hasKeys(sample, set));
        if (!matches) {
        return { ok: false, reason: `This file does not match ${platform} export format (missing ChatGPT signature keys).` };
        }
        return { ok: true };
    }

    return { ok: true };
} export { validateConversationSignature };